/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountingBox__OrganisationSettingsFragment = { __typename: 'OrganisationSetting', id: string, invoiceNumberMinLength: number, invoiceNumberPrefix: string, timeReportNumberMinLength: number, timeReportNumberPrefix: string, purchaseOrderNumberMinLength: number, purchaseOrderNumberPrefix: string, crmOrganisationNumberMinLength: number, crmOrganisationNumberPrefix: string, crmUserNumberMinLength: number, crmUserNumberPrefix: string, quoteNumberMinLength: number, quoteNumberPrefix: string, requirementNumberMinLength: number, requirementNumberPrefix: string };

export type AccountingBox__OrganisationCountersFragment = { __typename: 'OrganisationCounter', id: string, invoiceCounter: number, timeReportCounter: number, purchaseOrderCounter: number, crmOrganisationCounter: number, crmUserCounter: number, quoteCounter: number, requirementCounter: number };

export type OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationVariables = Types.Exact<{
  input: Types.OrganisationSettingsUpdateInput;
}>;


export type OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation = { updateOrganisationSettings: { __typename: 'OrganisationSettingsUpdateResult', organisationSettings: { __typename: 'OrganisationSetting', id: string, invoiceNumberMinLength: number, invoiceNumberPrefix: string, timeReportNumberMinLength: number, timeReportNumberPrefix: string, purchaseOrderNumberMinLength: number, purchaseOrderNumberPrefix: string, crmOrganisationNumberMinLength: number, crmOrganisationNumberPrefix: string, crmUserNumberMinLength: number, crmUserNumberPrefix: string, quoteNumberMinLength: number, quoteNumberPrefix: string, requirementNumberMinLength: number, requirementNumberPrefix: string } } };

export type OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationVariables = Types.Exact<{
  input: Types.OrganisationCountersUpdateInput;
}>;


export type OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation = { updateOrganisationCounters: { __typename: 'OrganisationCountersUpdateResult', organisationCounters: { __typename: 'OrganisationCounter', id: string, invoiceCounter: number, timeReportCounter: number, purchaseOrderCounter: number, crmOrganisationCounter: number, crmUserCounter: number, quoteCounter: number, requirementCounter: number } } };

export const AccountingBox__OrganisationSettingsFragmentDoc = gql`
    fragment AccountingBox__OrganisationSettings on OrganisationSetting {
  id
  invoiceNumberMinLength
  invoiceNumberPrefix
  timeReportNumberMinLength
  timeReportNumberPrefix
  purchaseOrderNumberMinLength
  purchaseOrderNumberPrefix
  crmOrganisationNumberMinLength
  crmOrganisationNumberPrefix
  crmUserNumberMinLength
  crmUserNumberPrefix
  quoteNumberMinLength
  quoteNumberPrefix
  requirementNumberMinLength
  requirementNumberPrefix
}
    `;
export const AccountingBox__OrganisationCountersFragmentDoc = gql`
    fragment AccountingBox__OrganisationCounters on OrganisationCounter {
  id
  invoiceCounter
  timeReportCounter
  purchaseOrderCounter
  crmOrganisationCounter
  crmUserCounter
  quoteCounter
  requirementCounter
}
    `;
export const OrganisationPaymentAccountingBox_ModifyOrganisationSettingsDocument = gql`
    mutation OrganisationPaymentAccountingBox_ModifyOrganisationSettings($input: OrganisationSettingsUpdateInput!) {
  updateOrganisationSettings(input: $input) {
    organisationSettings {
      id
      ...AccountingBox__OrganisationSettings
    }
  }
}
    ${AccountingBox__OrganisationSettingsFragmentDoc}`;
export type OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationFn = Apollo.MutationFunction<OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation, OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationVariables>;

/**
 * __useOrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation__
 *
 * To run a mutation, you first call `useOrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationPaymentAccountingBoxModifyOrganisationSettingsMutation, { data, loading, error }] = useOrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation, OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation, OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationVariables>(OrganisationPaymentAccountingBox_ModifyOrganisationSettingsDocument, options);
      }
export type OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationHookResult = ReturnType<typeof useOrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation>;
export type OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationResult = Apollo.MutationResult<OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation>;
export type OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationOptions = Apollo.BaseMutationOptions<OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutation, OrganisationPaymentAccountingBox_ModifyOrganisationSettingsMutationVariables>;
export const OrganisationPaymentAccountingBox_ModifyOrganisationCountersDocument = gql`
    mutation OrganisationPaymentAccountingBox_ModifyOrganisationCounters($input: OrganisationCountersUpdateInput!) {
  updateOrganisationCounters(input: $input) {
    organisationCounters {
      id
      ...AccountingBox__OrganisationCounters
    }
  }
}
    ${AccountingBox__OrganisationCountersFragmentDoc}`;
export type OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationFn = Apollo.MutationFunction<OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation, OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationVariables>;

/**
 * __useOrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation__
 *
 * To run a mutation, you first call `useOrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationPaymentAccountingBoxModifyOrganisationCountersMutation, { data, loading, error }] = useOrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation, OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation, OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationVariables>(OrganisationPaymentAccountingBox_ModifyOrganisationCountersDocument, options);
      }
export type OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationHookResult = ReturnType<typeof useOrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation>;
export type OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationResult = Apollo.MutationResult<OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation>;
export type OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationOptions = Apollo.BaseMutationOptions<OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutation, OrganisationPaymentAccountingBox_ModifyOrganisationCountersMutationVariables>;